import { AudienceType, RunAtType } from "../../config/enums";

const CommunicationEntityName = "g4c_communication";

function getAutomationAudienceRunAt(
  entityName,
  values = {},
  state = {}
) {
  switch (String(entityName || "").toLowerCase()) {
    case CommunicationEntityName:
      return values.RunAt || state.RunAt;
    default:
      return null;
  }
}

function validateAutomationAudienceRunAt(
  value,
  values,
  state,
  entityName
) {
  return String(value) === String(AudienceType.Automation) &&
    String(getAutomationAudienceRunAt(entityName, values, state)) !==
      String(RunAtType.Warehouse)
    ? "Automation audience type can only be used when Run At is Warehouse."
    : "";
}

export {
  CommunicationEntityName,
  getAutomationAudienceRunAt,
  validateAutomationAudienceRunAt,
};
